
    import { defineComponent } from 'vue';
    import { Navbar } from '@/apps/shared/models/navbar';
    export default defineComponent({
        name: 'Navbar',
        busEvents: {
            updateTitle(newTitle) {
                this.navbar.title = newTitle;
            },
            updateLogo(newLogo) {
                this.navbar.logo = newLogo;
            },
            showNavbar(show) {
                this.navbar.active = show;
            },
        },
        data() {
            return {
                navbar: {
                    title: "Sancor Seguros",
                    logo: {
                        src: "/logos/Logo_menu.svg",
                        href: "/",
                        alt: "Sancor Seguros",
                    },
                    active: true,
                } as Navbar,
            }
        },
        methods: {
            async redirectToHome() {
                sessionStorage.setItem("ExitOrContinueModal", "false");
                window.location.href = this.navbar.logo.href;
            },
        },
    });
